import { css } from 'lit';
import { color, rem } from '@thiememeulenhoff/lit-sdk';

export const styles = [
  css`
    :host {
      --progress-color: ${color('teal', 500)};
    }

    :host([orientation='horizontal']) {
      block-size: auto;
      inline-size: 100%;
    }

    :host([orientation='vertical']) {
      block-size: 100%;
      inline-size: auto;
    }

    .bar {
      background: ${color('white', 100)};
      border: ${rem(1)} solid var(--progress-color);
      border-radius: ${rem(20)};
      overflow: hidden;
    }

    .progress {
      background: var(--progress-color);
    }

    :host([orientation='horizontal']) .bar {
      inline-size: 100%;
    }

    :host([orientation='horizontal']) .progress {
      block-size: 100%;
      max-inline-size: 100%;
    }

    :host([orientation='vertical']) .bar {
      block-size: 100%;
    }

    :host([orientation='vertical']) .progress {
      inline-size: 100%;
      max-block-size: 100%;
    }
  `,
];
